// extracted by mini-css-extract-plugin
export default {"container":"OpenEvents_container__QT+2Y"};